import slugify from "../../helpers/slugify";
import importAll from "../../helpers/import-all";

const blogs = importAll(require.context("./posts", false, /\.js$/));

for (const blog of blogs) {
  blog.slug = slugify(blog.name);
}
export default blogs;
